import { jsPDF } from "jspdf";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackToHomeBtn from "../../components/BackToHomeBtn";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import uploadDocument from "../../services/uploadDocument";
import { convertBase64, resizeFile } from "../../utils/File";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const UploadFile = () => {
  useCookiesCheck();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);
  const [fileBase64, setFileBase64] = useState("");
  const [fileType, setFileType] = useState(2);
  const { t } = useTranslation();

  const submitHandler = async (e: any) => {
    e.preventDefault();
    dispatch(loaderActions.showLoader());

    const reqBody = {
      name: booking.bookingUsername,
      bookingNumber: booking.bookingNumber,
      base64document: fileBase64,
      type: fileType,
    };

    try {
      const response = await uploadDocument(reqBody);

      if (!response) {
        toast.error(
          "Unter der angegebenen Buchungsnummer existiert keine Reise in unserem System"
        );
        dispatch(loaderActions.hideLoader());
        return;
      }
      dispatch(loaderActions.hideLoader());
      navigate("/welcomeMsg");
    } catch (Ex: any) {
      dispatch(loaderActions.hideLoader());
      toast.error("send fail");
    }
  };

  const uploadHandler = async (e: any) => {
    dispatch(loaderActions.showLoader());
    const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 10e6; //10MB
    const file = e.target.files[0];
    const fileInput = e.target;

    // check on the type
    if (
      !allowedFormats.includes(file.type) &&
      !file.type.includes("doc") &&
      !file.type.includes("pdf")
    ) {
      dispatch(loaderActions.hideLoader());
      toast.info("The uploaded file is not valid");
      fileInput.value = "";
      return;
    }

    // Check on the size limit of the file.
    if (file.size > maxSize) {
      toast.error("Please upload a file smaller than 10 MB");
      dispatch(loaderActions.hideLoader());
      fileInput.value = "";
      return;
    }

    // conver the file to base64
    let base64 = await convertBase64(file);

    // Set the type of the file to be sent to the backend.
    if (file.type.includes("doc")) {
      setFileType(1);
    }

    // resize the file if it's an image and create pdf from it.

    if (allowedFormats.includes(file.type)) {
      try {
        // resize the file
        base64 = await resizeFile(file);
        let indexType = base64.indexOf("/");
        let resultType = base64.substr(indexType + 1);

        const imageOptions = {
          imageData: base64,
          format: resultType,
          x: 0,
          y: 0,
          width: 150,
          height: 150,
        };

        // Add the image to a pdf file
        const pdf = new jsPDF();
        pdf.addImage(imageOptions);

        // convert the pdf to base64
        base64 = pdf.output("datauristring");
      } catch (Ex: any) {
        dispatch(loaderActions.hideLoader());
        toast.error("Unkonw error in uploading, please try again.");
      }
    }

    let indexNum = base64.indexOf("base64,");
    let fileBase64 = base64.substr(indexNum + 7);
    setFileBase64(fileBase64);
    dispatch(loaderActions.hideLoader());
  };

  return (
    <div className="pageWrapper">
      <div className="container pt-2">
        <BackToHomeBtn />

        <div className="row justify-content-center">
          <div className="col-12 col-lg-4">
            <div className="cardWrapper">
              <form onSubmit={submitHandler}>
                <div className="mb-4">
                  <label className="form-label">{t("other.selectFile")}</label>
                  <input
                    type="file"
                    title="file"
                    accept=".pdf, .png, .jpg, .jpeg, .docx"
                    className="form-control"
                    onChange={uploadHandler}
                    required
                  />
                </div>

                <div className="mb-4 space-y-1">
                  <p></p>

                  <p>
                    <span className="fw-bold">{t("other.fileFormat")}: </span>{" "}
                    [jpeg, jpg, png, doc, pdf]
                  </p>

                  <p>
                    <span className="fw-bold">Max: </span> 10MB
                  </p>
                </div>

                <button
                  type="submit"
                  className="btn btn-warning text-white py-2 px-4 w-100"
                >
                  {t("other.upload")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadFile;
